import Fuse from 'fuse.js'

// To use import the Fuzzy constructor and instantiate a new instance
// ex. const fuzzy = new Fuzzy(data, {keys: ["name"]})
// keys refers to the searchable keys within your data collection
// once you have instantiated Fuzzy just call the search method with the string you want to search
// ex. fuzzy.search("find me")

export class Fuzzy<T> {
  private fuse: Fuse<T>

  constructor(
    collection: T[] = [],
    options: Fuse.IFuseOptions<T> = {},
    threshold: Fuse.IFuseOptions<T>['threshold'] = 0.10999,
  ) {
    this.fuse = new Fuse<T>(collection.slice(), {
      includeMatches: true,
      includeScore: true,
      ignoreFieldNorm: true,
      ignoreLocation: true,
      useExtendedSearch: true,
      shouldSort: true,
      threshold,
      ...options,
    })
  }

  search(search: string): T[] {
    return this.fuse.search(search).map(i => i.item)
  }
}
